require("dotenv").config()

export const backend = process.env.REACT_APP_BACKEND
export const productionBool = process.env.REACT_APP_PRODUCTION_BOOL === "true"
export const authServer = process.env.REACT_APP_AUTH_SERVER